module.exports = __webpack_public_path__ + "assets/media/6.ba5a3335.wav";